import { useEffect, useRef, useState } from "react"
import { Box, Modal, IconButton } from "@mui/material"
// import PlayButton from "../../../../assets/icons/white_play.svg?react"
// import { newGetIcons } from "../../../../utils/newGetIcons"

const VideoMessage = ({
  message,
  fullMessageData,
  thumbnail,
  index = 0,
  type,
}) => {
  const [open, setOpen] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(index)
  const videoRef = useRef(null)

  const handleOpen = () => {
    setCurrentIndex(index) // jis par click hua usi index se open
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
    if (videoRef.current) {
      videoRef.current.pause() // close pe video stop
      videoRef.current.currentTime = 0 // reset
    }
  }

  const handleNext = () => {
    setCurrentIndex((prev) =>
      prev === fullMessageData.length - 1 ? 0 : prev + 1
    )
  }

  const handlePrev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? fullMessageData.length - 1 : prev - 1
    )
  }

  useEffect(() => {
    if (open && videoRef.current) {
      videoRef.current.play().catch((err) => {
        console.log("Autoplay blocked:", err)
      })
    }
  }, [open])

  return (
    <>
      {/* Thumbnail with play button */}
      <div
        style={{
          position: "relative",
          cursor: "pointer",
          display: "flex",
          width: "fit-content",
        }}
        onClick={handleOpen}>
        {type === "Image" && (
          <img
            src={type === "Image" ? message : thumbnail}
            alt={type === "Image" ? "image available" : "video thumbnail"}
            style={{
              width: "180px",
              height: "180px",
              objectFit: "cover",
              borderRadius: "10px",
            }}
          />
        )}

        {type === "Video" && (
          <div
            style={{
              width: "180px",
              height: "180px",
              background: "#434343",
              borderRadius: "5px",
            }}>
            <span
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "80px",
                width: "80px",
                borderRadius: "50%",
                border: "1px solid white",
                paddingLeft: "7px",
              }}>
              {/* <PlayButton style={{ height: "30px", width: "30px" }} /> */}
              {">"}
            </span>
          </div>
        )}
      </div>

      {/* Modal */}
      <Modal
        open={open}
        // onClose={handleClose}
        aria-labelledby="video-modal"
        aria-describedby="video-player">
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "black",
            outline: "none",
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            // width: type === "Image" ? "38%" : "80%",
            width: type === "Image" ? "fit-content" : "80%",

            maxWidth: "800px",
            maxHeight:"600px"
          }}>
          <div style={{ position: "relative", width: "100%" }}>
            <span
              onClick={handleClose}
              style={{
                position: "absolute",
                height: "30px",
                width: "30px",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                top: "-35px",
                right: "-35px",
                color: "white",
                backgroundColor: "rgba(255,255,255,0.6)",
                "&:hover": { backgroundColor: "rgba(0,0,0,0.9)" },
              }}>
              <p
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginRight: "3px",
                  height: "15px",
                  width: "15px",
                }}>
                {/* {newGetIcons("close", "dark")} */}
                {"X"}
              </p>
            </span>
            {/* Video */}
            {type === "Video" && (
              <video
                src={fullMessageData[currentIndex]}
                controls
                autoPlay
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight:"600px",
                  borderRadius: "10px",
                }}
              />
            )}
            {type === "Image" && (
              <img
                style={{
                  height: "600px",
                  width: "600px",
                  objectFit:"contain",
                  borderRadius: "10px",
                }}
                src={fullMessageData[currentIndex]}
                alt="ALt image"
              />
            )}

            {/* Left Button */}
            <span
              onClick={handlePrev}
              style={{
                position: "absolute",
                height: "50px",
                width: "50px",
                borderRadius: "50%",
                display: currentIndex === 0 ? "none" : "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "40px",
                top: "50%",
                left: "-60px",
                transform: "translateY(-50%)",
                backgroundColor: "rgba(255,255,255,0.6)",
                cursor: "pointer",
              }}>
              {"<"}
            </span>

            {/* Right Button */}
            <span
              onClick={handleNext}
              style={{
                position: "absolute",
                height: "50px",
                width: "50px",
                borderRadius: "50%",
                display:
                  currentIndex === fullMessageData?.length - 1
                    ? "none"
                    : "flex",
                justifyContent: "center",
                alignItems: "center",
                top: "50%",
                fontSize: "40px",
                right: "-60px", // bahar shift
                transform: "translateY(-50%)",
                backgroundColor: "rgba(255,255,255,0.6)",
                cursor: "pointer",
              }}>
              {">"}
            </span>
          </div>
        </Box>
      </Modal>
    </>
  )
}

export default VideoMessage
